export const replaceTag = (element, newTag) => {
  const newElement: HTMLElement = document.createElement(newTag);
  // eslint-disable-next-line no-plusplus
  for (let i = 0, atts = element.attributes, n = atts.length; i < n; i++) {
    const att = atts[i];
    newElement.setAttribute(att.nodeName, att.nodeValue);
  }
  while (element.firstChild) {
    newElement.appendChild(element.firstChild);
  }
  element.parentNode.replaceChild(newElement, element);
};

export const versionComponent = async (cstr) => {
  const original = cstr.prototype.componentWillLoad;
  // eslint-disable-next-line no-param-reassign
  cstr.prototype.componentWillLoad = async function () {
    const breakOverride = async (...message) => {
      if (message.length > 0) {
        console.error(...message);
      }
      return original?.call(this);
    };
    const element: HTMLElement = this.el;
    if (!element) {
      return breakOverride(
        'It seems you tried to version a component without adding the "@Element" with the name "el"'
      );
    }
    const parentComponent =
      element.closest('.versioned') || (element.getRootNode() as any)?.host;
    const version = element.getAttribute('version') || parentComponent?.version;
    const oldComponentTag = element.tagName.toLowerCase();
    element.classList.add(oldComponentTag);
    if (!version) {
      return breakOverride();
    }
    try {
      // prettier-ignore
      const imported = await import(/* @vite-ignore */ `/../../${version}/standalone/${oldComponentTag}.js`);
      const { ...rest } = imported;
      const importedCstr: any = Object.values(rest)[0];
      importedCstr.prototype.version = version;
      const oldStyle = importedCstr.style;
      const newComponentTag = oldComponentTag.replace(
        '-',
        `-${version.split('.').join('-')}-`
      );
      Object.defineProperty(importedCstr, 'style', {
        get() {
          return oldStyle?.replaceAll(oldComponentTag, newComponentTag);
        },
      });
      customElements.define(newComponentTag, importedCstr);
      element.removeAttribute('version');
      element.classList.add('versioned');

      replaceTag(element, newComponentTag);
    } catch (e) {
      return breakOverride(
        `Tried to get version "${version}" of "${oldComponentTag}", but could not find it.`,
        e
      );
    }
    return breakOverride();
  };
};
